module.exports = __webpack_public_path__ + "static/media/Download.82410ff4.jpg";